import React from 'react'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import { SELECTED_FO_BORDER_COLOR } from './ganttFabricationOrderMarks'

/**
 * Story 175, RN47 (S147) -- the legend of the two border marks of the Gantt, next to its toolbar: the jobs of a
 * fabrication order that Sun classifies as late, and the jobs of the one selected fabrication order.
 * While an order is selected, a pill names it and its ✕ clears the selection in one click, from the Gantt
 * itself, without reopening the table row or the drawer entry that selected it (RN45 toggle, shortcut).
 */
// Story 177 (PO decision, 02/10, RN67): the two swatches go. What
// stays is the pill of the selected order with its ✕, which only shows while an order is selected.
const GanttLegend = ({ hasSelection = false, selectedFabricationOrderCode = '', onClearSelection }) => {
  const { t_ } = useSmartTranslation()
  if (!hasSelection || !onClearSelection) return null
  const selectionLabel = selectedFabricationOrderCode !== ''
    ? `${t_('Selected FO')}: ${selectedFabricationOrderCode}`
    : t_('Selected FO')
  return (
    <Stack direction='row' spacing={2} alignItems='center' justifyContent='flex-end' data-testid='gantt-legend'>
      <Chip
        size='small'
        variant='outlined'
        label={selectionLabel}
        onDelete={onClearSelection}
        onClick={onClearSelection}
        data-testid='gantt-selected-fo-chip'
        sx={{
          borderColor: 'transparent',
          backgroundColor: 'rgba(10, 132, 255, 0.16)',
          color: SELECTED_FO_BORDER_COLOR,
          borderRadius: '999px',
          fontWeight: 700,
          // MUI's own `.MuiChip-clickable:hover` is more specific than a plain `&:hover`: name it so the tint wins.
          '&:hover, &.MuiChip-clickable:hover': { backgroundColor: 'rgba(10, 132, 255, 0.24)' },
          '& .MuiChip-deleteIcon': { color: SELECTED_FO_BORDER_COLOR },
          '& .MuiChip-deleteIcon:hover': { color: SELECTED_FO_BORDER_COLOR, opacity: 0.8 }
        }}
      />
    </Stack>
  )
}

export default GanttLegend
